import React, { useEffect, useState } from "react";
import { Box, Popover, Typography, Stack } from "@mui/material";
import AccountCheckbox from "./account-checkbox.jsx";
import "../../../styles/analytics/account-selector.scss";
import PlatformIcon from "../../common/platform-icon.jsx";

const AccountDropdown = ({ accountCheckList, setAccountCheckList }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const accLabelsByKey = {
    twitter: "Twitter",
    facebook: "Facebook",
    linkedin: "LinkedIn",
    instagram: "Instagram",
    threads: "Threads",
    tiktok: "TikTok",
    pinterest: "Pinterest",
    youtube: "YouTube",
    gmb: "Google Business Profile",
  };

  const toggleAccount = (key, id) => {
    setAccountCheckList({
      ...accountCheckList,
      [key]: accountCheckList[key].map((acc) => {
        if (acc.accountId === id) {
          return { ...acc, checked: !acc.checked };
        }
        return acc;
      }),
    });
  };

  const toggleGroup = (key, value) => {
    setAccountCheckList({
      ...accountCheckList,
      [key]: accountCheckList[key].map((acc) => ({ ...acc, checked: value })),
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);

  const accKeys = Object.keys(accountCheckList);
  const accCount = Object.values(accountCheckList).reduce(
    (sum, data) => sum + data.filter((acc) => acc.checked).length,
    0
  );

  const isSelectedAllAccs = () => {
    const accountCheckListValues = Object.values(accountCheckList);
    for (let i = 0; i < accountCheckListValues.length; i++) {
      if (accountCheckListValues[i].find((acc) => !acc.checked)) {
        return false;
      }
    }
    return true;
  };

  const toggleAll = (value) => {
    const newCheckList = {};
    Object.keys(accountCheckList).map((key) => {
      newCheckList[key] = accountCheckList[key].map((acc) => ({
        ...acc,
        checked: value,
      }));
    });
    setAccountCheckList(newCheckList);
  };

  const getPopoverWidth = () => {
    const width = document.getElementById("account-dropdown")?.offsetWidth;

    return `${width || 330}px`;
  };

  const selectOnlyOneAcc = (id) => {
    const newCheckList = {};
    Object.keys(accountCheckList).map((key) => {
      newCheckList[key] = accountCheckList[key].map((acc) => ({
        ...acc,
        checked: acc.accountId === id,
      }));
    });

    setAccountCheckList(newCheckList);
  };

  const selectOnlyOneGroup = (groupKey) => {
    const newCheckList = {};
    Object.keys(accountCheckList).map((key) => {
      newCheckList[key] = accountCheckList[key].map((acc) => ({
        ...acc,
        checked: key === groupKey,
      }));
    });

    setAccountCheckList(newCheckList);
  };

  return (
    <Box
      className="account-dropdown-container"
      sx={{ zIndex: open ? 9999 : 1 }}
    >
      <Box
        id="account-dropdown"
        className="account-selector-container"
        style={{
          borderBottomLeftRadius: open ? "0px" : "5px",
          borderBottomRightRadius: open ? "0px" : "5px",
          boxShadow: open ? "none" : "0 10px 20px 0 rgba(105, 143, 183, 0.1)",
        }}
        onClick={handleOpen}
      >
        <Stack direction="row" spacing={"20px"} alignItems="center">
          <Box className="profile-pic analytics-icon">
            <img height="30px" src="https://d23ypky16g08sh.cloudfront.net/res/all-analytics.png" />
          </Box>

          <Stack direction="row" spacing={"10px"} alignItems="center">
            <Typography
              component="span"
              sx={{ fontSize: "16px", fontWeight: "bold", color: "#1D2952" }}
            >
              All Accounts
            </Typography>
            <Box
              sx={{
                backgroundColor: "#6B7280",
                width: "4px",
                height: "4px",
                borderRadius: "50px",
              }}
            />
            <Typography
              component="span"
              sx={{ fontSize: "16px", color: "#6B7280" }}
            >
              {accCount} {accCount == 1 ? "Account" : "Accounts"}
            </Typography>
          </Stack>
        </Stack>

        {accCount > 0 && (
          <i
            className={`fa ${
              open ? "fa-caret-up" : "fa-caret-down"
            } dropdown-icon`}
            aria-hidden="true"
          ></i>
        )}
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
            overflow: "hide",
            boxShadow: "rgba(0, 0, 0, 0.25) 0px 4px 14px 0px",
          },
        }}
      >
        <Stack
          className="account-dropdown-popover"
          sx={{
            width: getPopoverWidth(),
            paddingBottom: "10px",
            paddingRight: "10px",
          }}
        >
          <Stack
            spacing={"10px"}
            sx={{ overflowY: "auto", overflowX: "hidden" }}
          >
            <AccountCheckbox
              checked={isSelectedAllAccs()}
              onChange={() => toggleAll(!isSelectedAllAccs())}
              label={
                <Typography
                  component="span"
                  sx={{
                    fontSize: "14px",
                    color: "#4A4D52",
                    fontWeight: "bold",
                  }}
                >
                  Select All Accounts
                </Typography>
              }
            />

            <Box>
              <Stack justifyContent="center" spacing="20px">
                {accKeys.map((key) => (
                  <Box key={key}>
                    <AccountCheckbox
                      checked={!accountCheckList[key].find((x) => !x.checked)}
                      onChange={() =>
                        toggleGroup(
                          key,
                          !!accountCheckList[key].find((x) => !x.checked)
                        )
                      }
                      label={
                        <Stack
                          direction="row"
                          alignItems="center"
                          sx={{
                            "&:hover": {
                              ".acc-text-link": {
                                display: "block",
                              },
                            },
                          }}
                        >
                          <PlatformIcon
                            platform={{ type: key }}
                            classes="fa fa-fw acc-social-icon"
                            styles={{ marginRight: "12px", fontSize: "16px" }}
                          ></PlatformIcon>

                          <Box
                            className="checkbox-label"
                            sx={{
                              width: `${
                                getPopoverWidth().replace("px", "") - 145
                              }px`,
                            }}
                          >
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "14px",
                                color: "#4A4D52",
                                fontWeight: "bold",
                              }}
                            >
                              {accLabelsByKey[key]}
                            </Typography>
                          </Box>

                          <Box
                            onClick={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              selectOnlyOneGroup(key);
                            }}
                          >
                            <Typography className="acc-text-link">
                              Only
                            </Typography>
                          </Box>
                        </Stack>
                      }
                    />

                    {accountCheckList[key].map((account) => (
                      <AccountCheckbox
                        key={account.accountId}
                        checked={account.checked}
                        onChange={() => toggleAccount(key, account.accountId)}
                        label={
                          <Stack
                            direction="row"
                            alignItems="center"
                            sx={{
                              "&:hover": {
                                ".acc-text-link": {
                                  display: "block",
                                },
                                ".checkbox-label": {
                                  width: `${
                                    getPopoverWidth().replace("px", "") - 150
                                  }px`,
                                },
                              },
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "90%",
                              }}
                            >
                              <Box className="profile-pic profile-icon">
                                <img
                                  height="30px"
                                  src={account.profilePicUrl}
                                />
                              </Box>

                              <Typography
                                component="span"
                                sx={{
                                  width: `${
                                    getPopoverWidth().replace("px", "") - 130
                                  }px`,
                                  fontSize: "14px",
                                  color: "#4A4D52",
                                }}
                                className="checkbox-label"
                              >
                                {account.name}
                              </Typography>
                            </Box>

                            <Box
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                selectOnlyOneAcc(account.accountId);
                              }}
                            >
                              <Typography className="acc-text-link">
                                Only
                              </Typography>
                            </Box>
                          </Stack>
                        }
                      />
                    ))}
                  </Box>
                ))}
              </Stack>
            </Box>
          </Stack>
        </Stack>
      </Popover>
    </Box>
  );
};

export default AccountDropdown;
